export default __webpack_public_path__ + "static/Rhyme1-fdba52cad2027a946b6168f660206da0.mp3";